import { Utils, C } from '@kineticdata/bundle-common';
import { List, Map, Record } from 'immutable';
const { noPayload, withPayload } = Utils;
const ns = Utils.namespaceBuilder('services/requests');

export const tabLabels = [
  { type: 'Open', label: 'Open' },
  { type: 'Draft', label: 'Draft' },
  { type: 'Closed', label: 'Closed' },
  {
    type: 'OtherOpen',
    label: 'Other Open',
    filter: profile => profile.hasAgreements,
  },
  {
    type: 'OtherClosed',
    label: 'Other Closed',
    filter: profile => profile.hasAgreements,
  },
];

export const typeStates = Map({
  Open: C.CORE_STATE_SUBMITTED,
  Draft: C.CORE_STATE_DRAFT,
  Closed: C.CORE_STATE_CLOSED,
  OtherOpen: C.CORE_STATE_SUBMITTED,
  OtherClosed: C.CORE_STATE_CLOSED,
});

export const searchFields = [
  {
    id: 'tic',
    label: 'Ticket Number',
    value: `values[${C.FIELD_TICKET_NUMBERS}]`,
    combo: [],
  },
  {
    id: 'form',
    label: 'Form',
    value: `values[${C.FIELD_REQUEST_FORM_SLUG}]`,
    combo: ['by', 'agreement'],
    type: 'form',
  },
  {
    id: 'for',
    label: 'Requested For',
    value: `values[${C.FIELD_REQUESTED_FOR}]`,
    combo: [],
    type: 'user',
  },
  {
    id: 'by',
    label: 'Submitted By',
    value: 'submittedBy',
    combo: ['form', 'agreement'],
    type: 'user',
  },
  {
    id: 'agreement',
    label: 'Agreement',
    value: `values[${C.FIELD_AGREEMENT}]`,
    combo: ['form', 'by'],
  },
  {
    id: 'server',
    label: 'Server',
    value: `values[${C.FIELD_SERVER_NAMES}]`,
    combo: [],
  },
  {
    id: 'project',
    label: 'Project',
    value: `values[${C.FIELD_PROJECT}]`,
    combo: [],
  },
  {
    id: 'tracking',
    label: 'Customer Tracking Number',
    value: `values[${C.FIELD_TRACKING_NUMBER}]`,
    combo: [],
  },
];

export const types = {
  FETCH_REQUESTS_REQUEST: ns('FETCH_REQUESTS_REQUEST'),
  FETCH_REQUESTS_CURRENT: ns('FETCH_REQUESTS_CURRENT'),
  FETCH_REQUESTS_PREVIOUS: ns('FETCH_REQUESTS_PREVIOUS'),
  FETCH_REQUESTS_NEXT: ns('FETCH_REQUESTS_NEXT'),
  FETCH_REQUESTS_SUCCESS: ns('FETCH_REQUESTS_SUCCESS'),
  FETCH_REQUESTS_FAILURE: ns('FETCH_REQUESTS_FAILURE'),
  FETCH_REQUESTS_RESET: ns('FETCH_REQUESTS_RESET'),
  FETCH_REQUESTS_CLEAR: ns('FETCH_REQUESTS_CLEAR'),
  COUNT_REQUESTS_REQUEST: ns('COUNT_REQUESTS_REQUEST'),
  COUNT_REQUESTS_COMPLETE: ns('COUNT_REQUESTS_COMPLETE'),
};

export const actions = {
  fetchRequestsRequest: withPayload(types.FETCH_REQUESTS_REQUEST),
  fetchRequestsCurrent: noPayload(types.FETCH_REQUESTS_CURRENT),
  fetchRequestsPrevious: noPayload(types.FETCH_REQUESTS_PREVIOUS),
  fetchRequestsNext: noPayload(types.FETCH_REQUESTS_NEXT),
  fetchRequestsSuccess: withPayload(types.FETCH_REQUESTS_SUCCESS),
  fetchRequestsFailure: withPayload(types.FETCH_REQUESTS_FAILURE),
  fetchRequestsReset: noPayload(types.FETCH_REQUESTS_RESET),
  fetchRequestsClear: noPayload(types.FETCH_REQUESTS_CLEAR),
  countRequestsRequest: withPayload(types.COUNT_REQUESTS_REQUEST),
  countRequestsComplete: withPayload(types.COUNT_REQUESTS_COMPLETE),
};

export const SearchState = Record({
  coreState: C.CORE_STATE_SUBMITTED,
  all: false,
  query: [],
});

export const State = Record({
  search: SearchState(),
  loading: true,
  error: null,
  data: null,
  limit: 10,
  direction: 'DESC',
  paging: false,
  pageToken: null,
  nextPageToken: null,
  previousPageTokens: List(),
  count: 0,
  countDone: false,
  counts: {},
});

const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_REQUESTS_REQUEST:
      return state
        .set('search', payload ? SearchState(payload) : state.search)
        .set('loading', true)
        .set('error', null)
        .set('data', null)
        .set('limit', (payload && payload.limit) || state.limit)
        .set('direction', (payload && payload.direction) || state.direction)
        .set('paging', false)
        .set('pageToken', null)
        .set('nextPageToken', null)
        .set('previousPageTokens', List())
        .set('count', 0)
        .set('countDone', false);
    case types.FETCH_REQUESTS_CURRENT:
      return state.set('paging', true);
    case types.FETCH_REQUESTS_PREVIOUS:
      return state
        .set('paging', true)
        .set('nextPageToken', null)
        .set('pageToken', state.previousPageTokens.last())
        .update('previousPageTokens', tokens => tokens.pop());
    case types.FETCH_REQUESTS_NEXT:
      return state
        .set('paging', true)
        .update('previousPageTokens', tokens => tokens.push(state.pageToken))
        .set('pageToken', state.nextPageToken)
        .set('nextPageToken', null);
    case types.FETCH_REQUESTS_SUCCESS:
      return state
        .set('loading', false)
        .set('data', List(payload.data))
        .set('error', null)
        .set('paging', false)
        .set('nextPageToken', payload.nextPageToken)
        .set(
          'count',
          payload.count + state.previousPageTokens.size * state.limit,
        )
        .set('countDone', !payload.countPageToken);
    case types.FETCH_REQUESTS_FAILURE:
      return state
        .set('loading', false)
        .set('data', null)
        .set('error', payload.error)
        .set('paging', false);
    case types.FETCH_REQUESTS_RESET:
      return state
        .set('search', SearchState())
        .set('loading', true)
        .set('error', null)
        .set('data', null)
        .set('paging', false)
        .set('pageToken', null)
        .set('nextPageToken', null)
        .set('previousPageTokens', List())
        .set('count', 0)
        .set('countDone', false);
    case types.FETCH_REQUESTS_CLEAR:
      return state
        .set('loading', false)
        .set('error', null)
        .set('data', null)
        .set('paging', false)
        .set('pageToken', null)
        .set('nextPageToken', null)
        .set('previousPageTokens', List())
        .set('count', 0)
        .set('countDone', false);
    case types.COUNT_REQUESTS_COMPLETE:
      return state.update('counts', counts => ({ ...counts, ...payload }));
    default:
      return state;
  }
};

export default reducer;
